import { createSelector } from 'reselect'

import { emptyArr } from 'util/arrays'
import {
  objectHashSerializer,
  functionSerializer,
  memoize,
} from 'util/memoization'

import { selectSidebarCardData } from './sidebar_cards'

const selectBase = state => state.emailMarketing

export const selectEmailMarketingIntegrations = createSelector(
  selectBase,
  emailMarketing => emailMarketing.data || emptyArr
)

export const selectEmailMarketingSubscriptions = state =>
  createSelector(selectSidebarCardData, selectData => id =>
    selectData(`legacy_${id}`)
  )(state)

const getList = memoize(integrations =>
  memoize(
    currentId => {
      const found = integrations.find(({ id }) => id === currentId)
      return found ? found.lists || emptyArr : emptyArr
    },
    { serializer: objectHashSerializer }
  )
)

export const selectEmailMarketingAvailableEmailLists = createSelector(
  selectEmailMarketingIntegrations,
  getList
)

const getSidebarData = memoize(
  getData =>
    memoize(currentId => {
      return getData(`legacy_${currentId}`) || emptyArr
    }),
  { serializer: functionSerializer }
)

export const selectEmailMarketingListsOfCustomer = createSelector(
  selectSidebarCardData,
  getSidebarData
)

const filterEmailLists = memoize(
  (emailLists, listsOfCustomer) =>
    memoize(currentId => {
      return emailLists(currentId).filter(
        list =>
          !listsOfCustomer(currentId)
            .map(({ id }) => id)
            .includes(list.id)
      )
    }),
  { serializer: functionSerializer }
)

export const selectEmailMarketingAvailableLists = createSelector(
  selectEmailMarketingAvailableEmailLists,
  selectEmailMarketingListsOfCustomer,
  filterEmailLists
)
